// src/pages/Home.js
import React from "react";
import { Link } from "react-router-dom";
import "../index.css";
import useSEO from "../seo/useSEO";

export default function Home() {
    useSEO({
    title: "Photographe à Nancy & Tomblaine | HLBK",
    description:
      "Photographe à Nancy et Tomblaine pour mariages, portraits, familles, événements et entreprises. Des images naturelles, humaines et soignées.",
    canonical: "https://hlbk.fr/",
    image: "https://hlbk.fr/images/og-default.jpg",
  });

    const structuredData = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    name: "HLBK Photo",
    url: "https://hlbk.fr/",
    image: "https://hlbk.fr/images/og-default.jpg",
    description:
      "Photographe à Nancy et Tomblaine pour particuliers et professionnels.",
    areaServed: [
      {
        "@type": "City",
        name: "Nancy",
      },
      {
        "@type": "City",
        name: "Tomblaine",
      },
      {
        "@type": "AdministrativeArea",
        name: "Grand Nancy",
      },
      {
        "@type": "AdministrativeArea",
        name: "Grand Est",
      },
    ],
  };

  return (
    <main className="hlbk-home">

      <script
  type="application/ld+json"
  dangerouslySetInnerHTML={{
    __html: JSON.stringify(structuredData),
  }}
/>

      {/* =====================================================
          HERO
      ====================================================== */}
      <section className="hlbk-home-hero">

        <div className="hlbk-home-hero-overlay" />

        <div className="hlbk-home-hero-content">

          <p className="hlbk-home-kicker">
            HLBK PHOTO • NANCY & TOMBLAINE
          </p>

          <h1>
            Des images qui racontent
            <span>ce qui compte vraiment.</span>
          </h1>

          <p className="hlbk-home-lead">
            Photographe basé à Tomblaine, j’accompagne particuliers
            et professionnels avec des images naturelles, soignées
            et pensées pour raconter une histoire.
          </p>

          <div className="hlbk-home-location">
            Tomblaine • Nancy & alentours • Grand Est
          </div>

          <div className="hlbk-home-actions">

            <Link
              to="/services"
              className="btn-cta btn-cta-red"
            >
              JE SUIS UN PARTICULIER
            </Link>

            <Link
              to="/professionnels"
              className="btn-cta hlbk-home-btn-light"
            >
              JE SUIS UN PROFESSIONNEL
            </Link>

          </div>

        </div>

      </section>


      {/* =====================================================
          DEUX UNIVERS
      ====================================================== */}
      <section className="hlbk-home-section">

        <div className="hlbk-home-container">

          <div className="hlbk-home-section-head">

            <p className="hlbk-home-eyebrow">
  HLBK PHOTO
</p>

<h2>
  Deux univers.
  <span>Un même regard.</span>
</h2>

<p>
  Particuliers ou professionnels, chaque projet demande une approche
  différente, mais toujours la même exigence dans les images.
</p>

          </div>


          <div className="hlbk-home-universe-grid">

            {/* PARTICULIERS */}
            <Link
              to="/services"
              className="hlbk-home-universe-card"
            >

              <img
                src="/images/services/mariage.jpg"
                alt="Photographie pour particuliers"
              />

              <div className="hlbk-home-universe-overlay" />

              <div className="hlbk-home-universe-content">

                <p>PARTICULIERS</p>

                <h3>
                  Vos moments.
                  <span>Vos histoires.</span>
                </h3>

                <div className="hlbk-home-universe-tags">
                  Mariage • Portrait • Famille • Événement
                </div>

                <span className="hlbk-home-universe-link">
                  Découvrir →
                </span>

              </div>

            </Link>


            {/* PROFESSIONNELS */}
            <Link
              to="/professionnels"
              className="hlbk-home-universe-card"
            >

              <img
                src="/images/services/entreprise.jpg"
                alt="Photographie professionnelle pour entreprises"
              />

              <div className="hlbk-home-universe-overlay" />

              <div className="hlbk-home-universe-content">

                <p>PROFESSIONNELS</p>

                <h3>
                  Votre activité.
                  <span>Votre image.</span>
                </h3>

                <div className="hlbk-home-universe-tags">
                  Portrait • Équipe • Reportage • Communication
                </div>

                <span className="hlbk-home-universe-link">
                  Découvrir →
                </span>

              </div>

            </Link>

          </div>

        </div>

      </section>


      {/* =====================================================
          GALERIE APERÇU
      ====================================================== */}
      <section className="hlbk-home-gallery-simple">

  <div className="hlbk-home-container">

    <div className="hlbk-home-section-head">

      <p className="hlbk-home-eyebrow">
        MON TRAVAIL
      </p>

      <h2>
        Des images naturelles,
        <span>vivantes et soignées.</span>
      </h2>

      <p>
        Découvrez une sélection de reportages, portraits,
        mariages et projets professionnels.
      </p>

      <Link
        to="/galerie"
        className="btn-cta hlbk-home-gallery-button"
      >
        VOIR LA GALERIE
      </Link>

    </div>

  </div>

</section>


      {/* =====================================================
          POURQUOI HLBK
      ====================================================== */}
      <section className="hlbk-home-section">

        <div className="hlbk-home-container">

          <div className="hlbk-home-section-head">

            <p className="hlbk-home-eyebrow">
              L’APPROCHE HLBK
            </p>

            <h2>
              Une photographie humaine,
              <span>simple et exigeante.</span>
            </h2>

          </div>


          <div className="hlbk-home-values">

            <article>

              <span>01</span>

              <h3>Naturel avant tout</h3>

              <p>
                Je recherche des images vivantes et sincères plutôt
                que des poses figées ou artificielles.
              </p>

            </article>


            <article>

              <span>02</span>

              <h3>Vous êtes accompagné</h3>

              <p>
                Lieux, poses, lumière ou organisation :
                je vous guide pour que la séance reste simple et fluide.
              </p>

            </article>


            <article>

              <span>03</span>

              <h3>Un regard professionnel</h3>

              <p>
                De la prise de vue à la retouche, chaque image est
                travaillée avec attention et cohérence.
              </p>

            </article>

          </div>

        </div>

      </section>


      {/* =====================================================
          LOCAL
      ====================================================== */}
     <section className="hlbk-home-local">

  <div className="hlbk-home-container hlbk-home-local-compact">

    <div>
      <p className="hlbk-home-eyebrow">
        PHOTOGRAPHE À TOMBLAINE
      </p>

      <h2>
        Tomblaine • Nancy
        <span>& Grand Est</span>
      </h2>
    </div>

    <p>
      Basé à Tomblaine, j’accompagne particuliers et professionnels
      à Nancy, dans son agglomération et plus largement dans le Grand Est
      selon les projets.
    </p>

  </div>

</section>


      {/* =====================================================
          CTA FINAL
      ====================================================== */}
      <section className="hlbk-home-final">

        <div className="hlbk-home-container">

          <p className="hlbk-home-eyebrow hlbk-home-eyebrow-light">
            VOTRE PROJET
          </p>

          <h2>
            Une histoire à raconter ?
          </h2>

          <p>
  Un mariage, un portrait, un événement ou un projet professionnel ?
  Parlons simplement de ce que vous souhaitez raconter en images.
</p>

          <Link
            to="/contact"
            className="btn-cta btn-cta-red"
          >
            PARLER DE VOTRE PROJET
          </Link>

        </div>

      </section>

    </main>
  );
}